// extracted by mini-css-extract-plugin
module.exports = {"spinSize":"Config_spinSize__GMpYT"};